module.exports = __webpack_public_path__ + "static/media/add.831978d5.svg";